import { Title } from 'shared-components';
import { QueryKeys } from '@/types';
import _ from 'lodash';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '@/store';

export function PageTitleComp() {
  const activeTab = useSelector(({ offersDashboard }: ApplicationState) => offersDashboard.currentTab);

  const titleParams = new URLSearchParams(window.location.search);
  const searchQuery = titleParams.get(QueryKeys.SEARCH);
  const pageNo = titleParams.get(QueryKeys.PAGE);
  const pageLabel = pageNo != null ? ` (page ${pageNo})` : '';
  const searchLabel = searchQuery != null ? `"${searchQuery}" search on ` : '';
  const pageTitle = `${searchLabel}${activeTab}${pageLabel}`;

  return <Title title={pageTitle} />;
}

// Upates when active tab changes.
export const PageTitle = memo(PageTitleComp, (prev, next) => prev === next);
